import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Grid, Paper,
    List, ListItemButton, ListItemAvatar, Avatar, ListItemText, CircularProgress,
    Typography, Button
} from '@mui/material';
import { Article as ArticleIcon } from '@mui/icons-material';
import HowSearchWorksDialogContent from '../ResultsTable/HowSearchWorksDialogContent';
import ScoreIndicator from '../../Common/ScoreIndicator';

export const ProfilesDialog = ({ open, onClose, profiles, isLoading, onSelect }) => (
    <Dialog open={open} onClose={onClose}>
        <DialogTitle>Select an Ideal Candidate Profile</DialogTitle>
        <List sx={{ pt: 0, minWidth: '300px' }}>
            {isLoading ? <CircularProgress sx={{ m: 2 }} /> : profiles.map((profile) => (
                <ListItemButton onClick={() => onSelect(profile)} key={profile.id}>
                    <ListItemAvatar><Avatar><ArticleIcon /></Avatar></ListItemAvatar>
                    <ListItemText primary={profile.title} />
                </ListItemButton>
            ))}
        </List>
    </Dialog>
);

export const HelpDialog = ({ open, onClose }) => (
    <Dialog open={open} onClose={onClose}>
        <DialogTitle>How Our Search Works</DialogTitle>
        <DialogContent>
            <HowSearchWorksDialogContent />
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose}>Got it</Button>
        </DialogActions>
    </Dialog>
);

export const CompareDialog = ({ open, onClose, candidates }) => (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Compare Candidates</DialogTitle>
        <DialogContent>
            <Grid container spacing={2}>
                {candidates.slice(0, 3).map(c => (
                    <Grid item xs={12} md={4} key={c.uuid}>
                        <Paper variant="outlined" sx={{ p: 2 }}>
                            <Typography variant="h6">{c.name}</Typography>
                            <Typography color="text.secondary">{c.email}</Typography>
                            <ScoreIndicator score={c.final_score} type="radial" />
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </DialogContent>
        <DialogActions><Button onClick={onClose}>Close</Button></DialogActions>
    </Dialog>
);
